
import React, { useEffect, useRef, useState } from 'react';

import * as Components from '../../components';

import './accessesComponent.scss';
import { FileExcelOutlined, LoadingOutlined } from '@ant-design/icons';
import { render } from '@testing-library/react';
import moment from 'moment';
import RestApiClient from '../../api/restApiClient';
import ApiResponse from '../../models/api/ApiResponse';
import SportCenter from '../../models/SportCenter';

interface Props{

}

const AccessesComponent = (props: Props) : JSX.Element => {
      const accessesRef = useRef();
      const restApiClient : RestApiClient = new RestApiClient();
      const [ reloadCounter, setReloadCounter] = useState<number>(0);

        const [downloadingExcel, setDownloadingExcel] = useState<boolean>(false);
        const downloadExcelAccesses = async () => {
            
            setDownloadingExcel(true);

            let searchText : string = '';

            if (accessesRef && accessesRef.current){
                searchText = await (accessesRef.current as any).getFilter();
            }

            await restApiClient.exportExcel(`Accesses/GetAccessesExcel?criteria=${searchText}`).then((blob :any) => {
                const url = window.URL.createObjectURL(
                new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                'download',
                `accesos_rfid.xlsx`,
                );

                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                link.remove();
            }).finally(()=>{
            setDownloadingExcel(false);
            });


        }

        const [filters, setFilters] = useState<any[]>([]);

        const getSportCenters = () : void => {
            restApiClient.fetch("GetSportCenters", {})
                    .then((r : ApiResponse | null) => {
                        if (r?.code === 200){
                            setFilters([...filters, 
                                ...r.data?.map((sc: SportCenter)=> {
                                    return {label:sc.description, value: sc.description};
                                })])
                        }
                    })
        }
        
        useEffect(()=>{
            getSportCenters();
        },[]);
      
      const columns : any = [
          {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            width: 50
          },
          {
            title: 'Nombre atleta',
            dataIndex: 'athleteName',
            key: 'athleteName',
            width: 50,
            render: (text: string, record: any) => (
                <div>{record.athleteSurname.toUpperCase()} {record.athleteSecondSurname.toUpperCase()}, {record.athleteName.toUpperCase()} </div>
            ),
          },
          {
            title: 'F. Registro',
            dataIndex: 'recordDate',
            key: 'recordDate',
            width:120,
            render: (text: string) => (
                <div>{moment(text).format('DD/MM/YYYY HH:mm:ss')}</div>
            ),
          },
          {
            title: 'Centro',
            dataIndex: 'sportCenterName',
            key: 'sportCenterName',
            width:120
          },
        ];

    return(
        <div className="accesses-component">
            <Components.TablePagination
                    ref={accessesRef} 
                    entityName="accesses"
                    reloadCounter={reloadCounter}
                    aliasEndPoint="GetUserAccesses"
                    columns={columns}
                    title={"Listado de accesos"}
                    subtitle={<small style={{display:"block", fontSize:"11px"}}>¿Sabías que...¿Puedes configurar un terminal por cada centro dado de alta? Así podrás saber desde donde han usado su tarjeta.</small>}
                    loadingData = {false}
                    useTableScroll = {true}
                    hideTextOfFiltersAndButtonsOnMobile = {true}
                    filterButtons={filters}
                    actionButtons={[{styles:{width: "auto", backgroundColor: "green", borderColor: "green"}, label:"Descargar Excel", action: downloadExcelAccesses, icon: downloadingExcel ? <LoadingOutlined style={{color: "white"}}/> : <FileExcelOutlined style={{color: "white"}}/>}]}
                />
        </div>
    )
}

export default AccessesComponent;